module.exports = __webpack_public_path__ + "img/icon-cognitive-training.5050c809.png";